import * as React from 'react';

// @ts-expect-error - imported from .js/.jsx file
import {ArrowRightIcon} from '../../icon/svg/arrow-right-icon';

import styles from './see-all-button.module.css';

type Props = {
    onClick: () => void;
    text: string;
};

export function SeeAllButton(props: Props) {
    return (
        <button onClick={props.onClick} className={styles['see-all-button']}>
            <div onClick={props.onClick} className={styles.arrow}>
                <ArrowRightIcon wrapWithDiv={false} size={30} />
            </div>
            <span>{props.text}</span>
        </button>
    );
}
